import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';


import { IconButton, Switch, Tooltip } from '@mui/material';


const GeneratorsRow = ({ row, updateForm, onDelete, index, handleActive }) => {
  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.IdCompany}
      </TableCell>
      <TableCell align="center" key={index}>{row.Company}</TableCell>
      <TableCell align="center" style={{ maxWidth: '150px' }} key={index}>{row.CreateDate}</TableCell>
      <TableCell align="center">
        <Switch checked={row.Active} onChange={(e) => { handleActive(row.IdCompany, e.target.checked) }} />
      </TableCell>

      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdCompany) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default GeneratorsRow;